import React from "react";
import { C } from "../constants";
import { FancyInput, FancyTextarea } from "./FormControls";

/**
 * Compact team switcher. Status is a dot — team name is not repeated in every label.
 */
export default function TeamProblemMap({
  teams = [],
  activeKey = "",
  onSelect,
  onChangeTeam,
  editable = false,
}) {
  const list = (teams || []).filter((t) => (t.members || []).length);
  if (list.length < 2) return null;

  const selected = list.find((t) => t.key === (activeKey || list[0]?.key)) || list[0];
  const names = (selected?.members || []).map((m) => m.name).filter(Boolean).join(", ");

  return (
    <div style={{ marginBottom: editable ? 16 : 14 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        {list.map((t) => {
          const active = selected?.key === t.key;
          const missing = !String(t.problemStatement || "").trim();
          const verified = !!t.verified;
          const dot = missing ? C.error : verified ? "#0F9F6E" : C.faint;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => onSelect?.(t.key)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "7px 12px",
                borderRadius: 999,
                cursor: onSelect ? "pointer" : "default",
                fontSize: 13,
                fontWeight: 650,
                border: `1px solid ${active ? C.primary : C.border}`,
                background: active ? C.primary : C.surface,
                color: active ? "#fff" : C.text,
              }}
            >
              <span
                aria-hidden
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: active ? "#fff" : dot,
                  opacity: active ? 0.95 : 1,
                }}
              />
              {t.name || "Unassigned"}
            </button>
          );
        })}
      </div>
      {selected && (
        <p style={{ margin: "8px 0 0", fontSize: 12.5, color: C.muted, fontWeight: 500, lineHeight: 1.4 }}>
          {(selected.members || []).length} member{(selected.members || []).length === 1 ? "" : "s"}
          {names ? ` · ${names}` : ""}
          {selected.verified ? " · verified" : ""}
        </p>
      )}
      {editable && selected && (
        <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
          <FancyInput
            tone="navy"
            icon="ti-users-group"
            label="Team name"
            value={selected.name || ""}
            onChange={(e) => onChangeTeam?.(selected.key, { name: e.target.value })}
            placeholder="e.g. Team Alpha"
          />
          <FancyTextarea
            tone="ink"
            label="Problem statement"
            value={selected.problemStatement || ""}
            onChange={(e) => onChangeTeam?.(selected.key, { problemStatement: e.target.value })}
            placeholder="Full detailed problem for this team only"
            rows={12}
            style={{ minHeight: 220 }}
          />
        </div>
      )}
    </div>
  );
}
